function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1200 1200"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M594 1074c-265.2 0-480-214.8-480-480s214.8-480 480-480 480 214.8 480 480-214.8 480-480 480zm217.2-637.2c-14.4-14.4-37.2-14.4-51.6 0L530.4 672l-102-105.6c-14.4-14.4-37.2-14.4-51.6 0-14.4 14.4-14.4 38.4 0 52.8l128.4 132c14.4 14.4 37.2 14.4 51.6 0l255.6-261.6c13.2-14.4 13.2-38.4-1.2-52.8z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#a6a6a6"
})));